import { NgModule } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { ReportComponent } from './components/report/report.component';
import { ReportPrimaryComponent } from './components/report-primary/report-primary.component';
import { ReportExtendedComponent } from './components/report-extended/report-extended.component';
import { SharedModule } from '../shared/shared.module';
import { ScrollToModule } from '@nicky-lenaers/ngx-scroll-to';
import { CeidgStatusPipe } from '../shared/pipes/ceidg-status.pipe';
import { ReportWrapperComponent } from './components/report-wrapper/report-wrapper.component';



@NgModule({
  declarations: [
    ReportComponent,
    ReportPrimaryComponent,
    ReportExtendedComponent,
    ReportWrapperComponent,

  ], imports: [CommonModule, SharedModule, ScrollToModule, CeidgStatusPipe],
  providers: [ DatePipe ]
})
export class ReportsModule { }
